import React from 'react';
import { Twitter, Facebook, Heart, MessageCircle, Repeat, Share2 } from 'lucide-react';
export function LivePostDisplay() {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-73">
      {/* Twitter Column */}
      <div className="border rounded-lg overflow-hidden" data-id="element-74">
        <div className="bg-[#1DA1F2] p-3 flex items-center gap-2" data-id="element-75">
          <Twitter size={18} className="text-white" data-id="element-76" />
          <h3 className="text-white font-medium" data-id="element-77">Twitter</h3>
        </div>
        <div className="p-4 space-y-4" data-id="element-78">
          {/* Twitter Post */}
          <div className="border rounded-lg p-4" data-id="element-79">
            <div className="flex items-start gap-3" data-id="element-80">
              <div className="w-10 h-10 rounded-full bg-gray-300 flex-shrink-0" data-id="element-81"></div>
              <div className="flex-1" data-id="element-82">
                <div className="flex items-center gap-2" data-id="element-83">
                  <span className="font-medium" data-id="element-84">Your Brand</span>
                  <span className="text-gray-500 text-sm" data-id="element-85">@yourbrand</span>
                  <span className="text-gray-500 text-sm" data-id="element-86">· 2h</span>
                </div>
                <p className="my-2" data-id="element-87">
                  Just launched our new product line! 🚀 Excited to see what our
                  community thinks. #innovation #startup
                </p>
                <div className="flex items-center gap-6 mt-3 text-gray-500" data-id="element-88">
                  <div className="flex items-center gap-1" data-id="element-89">
                    <Heart size={16} data-id="element-90" />
                    <span className="text-xs" data-id="element-91">47</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-92">
                    <Repeat size={16} data-id="element-93" />
                    <span className="text-xs" data-id="element-94">12</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-95">
                    <MessageCircle size={16} data-id="element-96" />
                    <span className="text-xs" data-id="element-97">5</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Pinned High-Performing Post */}
          <div className="border rounded-lg p-4" data-id="element-98">
            <div className="flex items-start gap-3" data-id="element-99">
              <div className="w-10 h-10 rounded-full bg-gray-300 flex-shrink-0" data-id="element-100"></div>
              <div className="flex-1" data-id="element-101">
                <div className="flex items-center gap-2" data-id="element-102">
                  <span className="font-medium" data-id="element-103">Your Brand</span>
                  <span className="text-gray-500 text-sm" data-id="element-104">@yourbrand</span>
                  <span className="text-gray-500 text-sm" data-id="element-105">· 1w</span>
                  <span className="text-xs bg-blue-100 text-blue-600 px-2 py-0.5 rounded-full" data-id="element-106">
                    Pinned
                  </span>
                </div>
                <p className="my-2" data-id="element-107">
                  We're hiring! Join our growing team of innovators and
                  creators. Check out open positions at our website. #careers
                  #hiring
                </p>
                <div className="flex items-center gap-6 mt-3 text-gray-500" data-id="element-108">
                  <div className="flex items-center gap-1" data-id="element-109">
                    <Heart size={16} className="text-red-500" data-id="element-110" />
                    <span className="text-xs" data-id="element-111">523</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-112">
                    <Repeat size={16} data-id="element-113" />
                    <span className="text-xs" data-id="element-114">78</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-115">
                    <MessageCircle size={16} data-id="element-116" />
                    <span className="text-xs" data-id="element-117">42</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Facebook Column */}
      <div className="border rounded-lg overflow-hidden" data-id="element-118">
        <div className="bg-[#1877F2] p-3 flex items-center gap-2" data-id="element-119">
          <Facebook size={18} className="text-white" data-id="element-120" />
          <h3 className="text-white font-medium" data-id="element-121">Facebook</h3>
        </div>
        <div className="p-4 space-y-4" data-id="element-122">
          {/* Facebook Post */}
          <div className="border rounded-lg p-4" data-id="element-123">
            <div className="flex items-start gap-3" data-id="element-124">
              <div className="w-10 h-10 rounded-full bg-gray-300 flex-shrink-0" data-id="element-125"></div>
              <div className="flex-1" data-id="element-126">
                <div className="flex items-center gap-2" data-id="element-127">
                  <span className="font-medium" data-id="element-128">Your Brand</span>
                  <span className="text-gray-500 text-sm" data-id="element-129">· 4h</span>
                </div>
                <p className="my-2" data-id="element-130">
                  Behind the scenes at our office today! Our team has been
                  working hard on something special for you all. Can you guess
                  what it is? 🤔✨
                </p>
                <div className="my-3 bg-gray-100 rounded-lg overflow-hidden" data-id="element-131">
                  <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&h=300&q=80" alt="Team working together" className="w-full h-48 object-cover" data-id="element-132" />
                </div>
                <div className="flex items-center gap-6 mt-3 text-gray-500" data-id="element-133">
                  <div className="flex items-center gap-1" data-id="element-134">
                    <Heart size={16} data-id="element-135" />
                    <span className="text-xs" data-id="element-136">156</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-137">
                    <Share2 size={16} data-id="element-138" />
                    <span className="text-xs" data-id="element-139">23</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-140">
                    <MessageCircle size={16} data-id="element-141" />
                    <span className="text-xs" data-id="element-142">31</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Low-Performing Post */}
          <div className="border rounded-lg p-4 bg-gray-50" data-id="element-143">
            <div className="flex items-start gap-3" data-id="element-144">
              <div className="w-10 h-10 rounded-full bg-gray-300 flex-shrink-0" data-id="element-145"></div>
              <div className="flex-1" data-id="element-146">
                <div className="flex items-center gap-2" data-id="element-147">
                  <span className="font-medium" data-id="element-148">Your Brand</span>
                  <span className="text-gray-500 text-sm" data-id="element-149">· 3d</span>
                  <span className="text-xs bg-amber-100 text-amber-600 px-2 py-0.5 rounded-full" data-id="element-150">
                    Low engagement
                  </span>
                </div>
                <p className="my-2" data-id="element-151">
                  Check out our updated terms of service and privacy policy on
                  our website.
                </p>
                <div className="flex items-center gap-6 mt-3 text-gray-500" data-id="element-152">
                  <div className="flex items-center gap-1" data-id="element-153">
                    <Heart size={16} data-id="element-154" />
                    <span className="text-xs" data-id="element-155">7</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-156">
                    <Share2 size={16} data-id="element-157" />
                    <span className="text-xs" data-id="element-158">1</span>
                  </div>
                  <div className="flex items-center gap-1" data-id="element-159">
                    <MessageCircle size={16} data-id="element-160" />
                    <span className="text-xs" data-id="element-161">0</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}